import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { ReportfilterComponent } from '../../grid/reportfilter/reportfilter.component';
@Component({
  selector: 'app-payadvreport',
  templateUrl: './payadvreport.component.html',
  styleUrls: ['./payadvreport.component.css']
})
export class PayadvreportComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "PayadvReport";

  fromdate: any = new Date();
  todate: any = new Date();

  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;

  payadvColl: any = [];
  empColl: any = [];

   

  searchtxt: any = "";


  columnDefs = [
    {
      headerName: 'Date', field: 'transdt',type:'date'
    },
    { headerName: 'Employee', field: 'empname' },
    {
      headerName: 'Adjustment Date', field: 'adjdt', type:'date'
    },
    { headerName: 'Amount', field: 'amount', type:'decimal' },
    { headerName: 'Status', field: 'approvedstatus' },


  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  }; 


  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }
      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
      if (params.fromdate !== undefined) {
        console.log(params.fromdate)
        console.log(this.fnConvertDatetime(params.fromdate))
        console.log(this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate)))
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        console.log(params.todate)
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetPayadvReport();
    this.fngetEmp();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
 




  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'payadvlist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
    
  }


  fnActionRefreshClick() {
    this.fngetPayadvReport()
  //  this.fngetEmp();
  }

  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetPayadvReport();

  }
  fnActionFilterClick() {  

    // this.filterbar.filterstatus = this.filterstatus;
    
    // this.isfilter = !this.isfilter;
    this. fnShowFilterPopup()
  }
  fnApplyFilterPop(data) {
    // this.isfilter = !this.isfilter;

    this.filterstatus = data;
    this.filteremployeeid = data.empid;
    this.filteremployeename = data.empname;
   

    this.fngetPayadvReport();

  }




  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    if (this.filteremployeeid > 0) {
      queryParams['empid'] = this.filteremployeeid;
    }
    if (this.filteremployeename != '') {
      queryParams['empname'] = this.filteremployeename;
    }
    if (this.filterfromdate != '') {
      queryParams['fromdate'] = this.fnFormatDatetime(this.filterfromdate);
    }
    if (this.filtertodate != '') {
      queryParams['todate'] = this.fnFormatDatetime(this.filtertodate);
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetPayadvReport();
    }
    else {
      this.filterstatus = "";
      this.fngetPayadvReport();
    }
  }

  //Get
  fngetEmp() {
    var data = {
      'empid': 0,
    }
    this.appService.getEmployeePayReport(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
         
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Get
  fngetPayadvReport() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'payadvid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus,
      'empid': this.filteremployeeid,
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),
    }
    this.appService.getPayadvReport(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.payadvColl = res.json().result;
            this.fnSetTable();
            this.fnCurrentRouteChange();

          } else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }






  fnSetTable() {
    
  }
  public fnSearchDatatable(value) {
   
  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.payadvColl[index].hoverfocus = "IN"
      }
      else {
        this.payadvColl[index].hoverfocus = ""
      }
    }
  }




  fnFormatDecimal(params) {
    if (params.value) {
      return params.value.toFixed(2)
    }
  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }
  
  }  
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  fnCloseForm() {
    try {
      this.router.navigate(['/Reports']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
    
  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(ReportfilterComponent, { size: <any>'xl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.empid = Number(this.filteremployeeid);


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)

      if (receivedEntry.status === 'DONE') {
        this.filteremployeeid = receivedEntry.empid;
        this.filteremployeename = receivedEntry.empname;
       
        this.fngetPayadvReport();
      }


    });
  }
  
  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.payadvColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}

